export enum Role_Enum {
  /** ADMIN */
  Master = 'master',
  /** SUPERUSER */
  Superuser = 'superuser',
  /** USER */
  User = 'user',
}
